import { httpClient } from 'utils/httpClient';

export interface ReniecDatos {
  nombres:         string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  sexo?:           'M' | 'F' | null;   // RENIEC lo devuelve cuando está disponible
}

export interface ReniecResult {
  dniValido: boolean;
  datos:     ReniecDatos | null;
}

export const reniecService = {
  async consultarDni(dni: string): Promise<ReniecResult> {
    return httpClient.get<ReniecResult>(`/usuarios/consulta-dni/${dni}`);
  },
};
